<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box" v-if="DeleteAccount">
        <div class="accountright_cont_box">
          <div class="flex_center_between_box account-left-box" style="align-items: center">
            <div>
              <div :class="imgedit ? 'account-left flex_center_between_box' : ' flex_center_between_box'">
                <div class="postiverelatibve">
                  <img :src="imageUrl" v-if="imageUrl" class="avatar" />
                  <div v-else class="avatar avatartex">
                    {{ userinfo?.userInfo?.firstName }}
                  </div>
                  <!-- <i  class="el-icon-edit avatar-uploader-icon"></i> -->
                  <div class="edit_con">
                    <svg @click="imgedit = true" t="1730092885407" class="icon edit_con_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5912" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25"><path d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z" fill="#ffffff" p-id="5913"></path></svg>
                  </div>
                </div>
                <div class="account-left-right account_base">
                  <!-- v-if="userType == 1" -->
                  <h3>
                    {{ userinfo?.userInfo?.firstName }}{{ userinfo?.userInfo?.lastName }}
                  </h3>
                  <!-- <h3 v-else>
                    {{ userinfo?.companyInfo?.firstName }} {{ userinfo?.companyInfo?.lastName }}
                  </h3> -->
                  <h4 v-if="userType == 1">
                   {{ $t('navigationBar.IndivdualAccount') }}
                  </h4>
                  <h4 v-else>
                    {{ $t('navigationBar.GroupAccount') }}
                  </h4>
                  <div class="account-left-right-time">
                    Registration time: {{ userinfo?.userInfo?.createTime }}
                  </div>
                </div>
                <div v-if="userType != 1" class="account-left-right role_company">
                  <h3>{{ userinfo?.companyInfo?.companyName}}</h3>
                  <h4  v-if="userType==3">Role: Administrator</h4>
                   <h4 v-if="userType==2">Role: Enterprise users </h4>
                </div>
              </div>
              <div class="account_btn" v-if="imgedit">

                <el-upload class="avatar-uploader account_btn" action="" :show-file-list="false" :auto-upload="false"
                  :on-preview="handlePictureCardPreview" :on-success="handleAvatarSuccess" :on-change="imgchange"
                  :before-upload="beforeAvatarUpload">



                  <el-button class="btn_blue flex_center logout_btn  btn_blue account_btn" style="margin-right: 10px;">Edit Image</el-button>
                </el-upload>
                <button @click="Deletapicture" class=" flex_center logout_btn"
                  :class="imageUrl == '' ? 'btn_blue btn_eee ' : 'btn_blue'" :disabled="imageUrl == ''">Delete Image</button>
              </div>
              
            </div>
       
            <div class="account_btn">
              <div style="display: flex">
                <button class="btn_blue flex_center logout_btn" @click="SubmitLoginOut">
                     {{$t('MyAccount.SignOut')}}  
                </button>
                <button class="btn_blue flex_center btn_eee del_btn" @click="DeleteAccountedlog()">
           {{$t('MyAccount.DeleteAccount')}}  
                </button>
              </div>
            </div>

          </div>
          <div class="flex_center_between_box content-center account_form_item">
            <div class="sel_box">
              <h4>{{ $t('MyAccount.AccountID') }}</h4>
              <el-input  v-model="Accountid" :disabled="EditOne" :placeholder="$t('MyAccount.Enteranewaddress')"
                @focus="errFlag = false">
              </el-input>
            </div>

            <div class="account_btn">
              <button class="btn_blue flex_center btn_eee change_btn" v-if="EditOne" @click="ChangeAccount()">
              {{$t('MyAccount.Change')}}
              </button>
              <div v-else style="display: flex">
                <button class="btn_blue flex_center change_btn_mr10" @click="ChangeAccountid()">
                  {{$t('MyAccount.Save')}}
                </button>
                <button class="btn_blue flex_center change_btn_gray" @click="ChangeAccount()">
                {{$t('MyAccount.Cancel')}}
                </button>
              </div>
            </div>
          </div>
          <div class="flex_center_between_box content-center account_form_itemA" v-if="!EditOne">
            <div class="sel_box">
              <el-input v-model="Emailcode" class="send_code_mar"  :placeholder="$t('MyAccount.EnterVerificationCode')"
                maxlength="20"></el-input>
              <span class="send_txt" v-show="setTimeForFlag" @click="sendCodeForgot">
             {{$t('MyAccount.SendverificationCode')}}
              </span>
              <div class="send_time" v-show="!setTimeForFlag">{{ setTimeFor }}s</div>
            </div>


          </div>
          <div class="flex_center_between_box content-center account_form_item">
            <div class="sel_box">
              <h4> {{$t('MyAccount.Password')}}</h4>
              <div class="information-content password_item_account">
                <div class=" computer_right_cont_box" style="width:100%">
                  <el-input v-model="password" :disabled="EditTwo" :type="type" :placeholder="$t('MyAccount.Originalpassword')" @focus="errFlag = false"
                    maxlength="20">
                    <i slot="suffix" class="icon_watch" :class="inputType ? 'icon_watchun' : 'icon_watchon'"
                      @click="inputType = !inputType"></i>
                  </el-input>
                </div>
              </div>
              <div v-if="PasswordChange">
                <div class="information-content password_item_account account_form_itemA">
                  <div class=" computer_right_cont_box" style="width:100%">
                    <el-input v-model="passwordtwo"  :type="inputTypetwo?'text':'password'" :placeholder="$t('MyAccount.Newpassword')" @focus="errFlag = false"
                      maxlength="20">
                      <i slot="suffix" class="icon_watch" :class="inputTypetwo ? 'icon_watchun' : 'icon_watchon'"
                        @click="inputTypetwo = !inputTypetwo"></i>
                    </el-input>
                  </div>
                </div>
                <div class="information-content password_item_account account_form_itemA">
                  <div class=" computer_right_cont_box" style="width:100%">
                    <el-input v-model="passwordtree" :type="inputTypetree?'text':'password'" :placeholder="$t('MyAccount.Confirmnewpassword')"
                      @focus="errFlag = false" maxlength="20">
                      <i slot="suffix" class="icon_watch" :class="inputTypetree ? 'icon_watchun' : 'icon_watchon'"
                        @click="inputTypetree = !inputTypetree"></i>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="account_btn">
              <button class="btn_blue flex_center btn_eee change_btn" v-if="EditTwo" @click=" EditTwo = !EditTwo;PasswordChange=true;">
              {{ $t('MyAccount.Change') }}
              </button>
              <div v-else style="display: flex">
                <button class="btn_blue flex_center change_btn_mr10" style="margin-right: 10px" @click="ChangePassword()">
                 {{ $t('MyAccount.Save') }}
                </button>
                <button class="btn_blue flex_center change_btn_gray" @click="changepass()">
                {{ $t('MyAccount.Cancel') }}
                </button>
              </div>
            </div>
          </div>
          <div>
            <div class="flex_center_between_box content-center account_form_item">
              <div class="sel_box account_form_item_box">
                <h4>{{ $t('MyAccount.AccountOwnership') }}</h4>
                <div v-if="EditTree" class="AccountOwnership">
                  <span  v-if="userType == 1">  {{ $t('navigationBar.IndivdualAccount') }}</span>
                  <span v-else>  {{ $t('navigationBar.GroupAccount') }}</span>
                </div>
              </div>

              <div class="account_btn">
                <button  class="btn_blue flex_center btn_eee change_btn" v-if="EditTree" @click="Changauthentication()">
                 {{ $t('MyAccount.Change') }}
                </button>
                <div v-else style="display: flex">
                  <button class="btn_blue flex_center change_btn_mr10" :class="userType == 1?'btn_blue':'btn_eee'" :disabled="userType != 1"  style="margin-right: 10px" @click="ChangeOwnership()">
                  {{ $t('MyAccount.Save') }}
                  </button>
                  <button class="btn_blue flex_center change_btn_gray" @click="EditTree = !EditTree">
                  {{ $t('MyAccount.Cancel') }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="!EditTree">
              <div class="margin-bottom20 flex_box">
                <el-radio v-model="radio" :disabled="userType==3||userType==2" label="1">   {{ $t('navigationBar.IndivdualAccount') }}</el-radio>
                <el-radio v-model="radio"  label="2">   {{ $t('navigationBar.GroupAccount') }}</el-radio>
              </div>
              <div class="his_sel_box" v-if="radio == '1'" style="width: 100%">
                <div class="information-content">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.companyName"
                     :placeholder="$t('MyAccount.Organizationname')"></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.firstName"
                    :placeholder="$t('MyAccount.FirstName')"></el-input>
                  </div>
                 
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-select style="width: 100%;" filterable  v-model="Peoplecertification.countryCode"
                     :placeholder="$t('MyAccount.CountryRegion')" class="fin_top_sel" @change="changeCountry">
                      <el-option v-for="item in countryOptions" :key="item.countryCode" :label="item.nameEn"
                        :value="item.countryCode"></el-option>
                    </el-select>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.lastName"
                      :placeholder="$t('MyAccount.LastName')"></el-input>
                  </div>
                  
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.address1"
                      :placeholder="$t('MyAccount.Address')"></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.phoneNumber"
                     :placeholder="$t('MyAccount.PhoneNumber')"></el-input>
                  </div>
                 
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" style="width: 100%;" clearable v-model="Peoplecertification.city"
                      :placeholder="$t('MyAccount.City')"></el-input>
                   
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" clearable v-model="Peoplecertification.email"
                      :placeholder="$t('MyAccount.Email')"></el-input>
                  </div>
                 
                  
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input"  clearable v-model="Peoplecertification.zipCode"
                      :placeholder="$t('MyAccount.ZipCode')"></el-input>
                  </div>
                 
                  
                </div>
              </div>
              <div class="his_sel_box" v-else style="width: 100%">
                <div class="information-content">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input"  :disabled="userType != 1" clearable v-model="Enterprisecertification.companyName"
                        :placeholder="$t('MyAccount.Organizationname')"></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.firstName"
                       :placeholder="$t('MyAccount.FirstName')"></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-select style="width: 100%;" :disabled="userType != 1" filterable v-model="Enterprisecertification.countryCode"
                       :placeholder="$t('MyAccount.CountryRegion')" class="fin_top_sel" @change="changeCountry">
                      <el-option v-for="item in countryOptions" :key="item.countryCode" :label="item.nameEn"
                        :value="item.countryCode"></el-option>
                    </el-select>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.lastName"
                    :placeholder="$t('MyAccount.LastName')" ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.address1"
                     :placeholder="$t('MyAccount.Address')"></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.phoneNumber"
                         :placeholder="$t('MyAccount.PhoneNumber')"></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.city"
                      :placeholder="$t('MyAccount.City')"></el-input>
                  
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.email"
                      :placeholder="$t('MyAccount.Email')"></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input class="inline-input" :disabled="userType != 1" clearable v-model="Enterprisecertification.zipCode"
                       :placeholder="$t('MyAccount.ZipCode')"></el-input>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="accountright_cont_box" style="margin-top: 10px; padding: 15px 40px">
          <ul class="ul-tab flex_between_box">
            <li>
              <h4 class="ul-tab-title">{{ $t('MyAccount.LastLogin') }}</h4>
              <h4 class="ul-tab-text">{{ lastLogDur }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">{{ $t('MyAccount.RecentLogin') }}</h4>
              <h4 class="ul-tab-text">{{ recentLoginTime }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">{{ $t('MyAccount.AverageLoginTime') }}</h4>
              <h4 class="ul-tab-text">{{ averageLoginTime }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">{{ $t('MyAccount.TotalLoginAttempts') }}</h4>
              <h4 class="ul-tab-text">{{ totalLogins }}</h4>
            </li>
          </ul>
        </div>
        <div class="accountright_cont_box" style="margin-top: 10px">
          <ul class="flex_center_star">
            <div class="ul-tab-left">
              <div class="ul-tab-left-rili">
                <div class="rili-top ">
                  <i class="rili-top-left flex_center" @click="YearNum--,Active(AvtiveValue,ActiveIndex)"><svg t="1726039901603" class="icon"
                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5401"
                      data-spm-anchor-id="a313x.manage_type_myprojects.0.i2.4d7f3a819Fvsz5" width="17" height="17">
                      <path
                        d="M705 923c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4l386-386c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4L354.4 512l368.3 368.3c9.8 9.8 9.8 25.6 0 35.4-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#1A2332" p-id="5402"></path>
                    </svg></i>
                  <span><svg t="1726040026069" class="icon iconrili" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="6007" width="20" height="20">
                      <path
                        d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                        p-id="6008" fill="#1A2332"></path>
                      <path
                        d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                        p-id="6009" fill="#1A2332"></path>
                    </svg> {{ YearNum }}</span>
                  <i class="rili-top-left flex_center" @click="YearNum++,Active(AvtiveValue,ActiveIndex)"><svg t="1726039944911" class="icon"
                      viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5834"
                      id="mx_n_1726039944912" width="17" height="17">
                      <path
                        d="M319 923c-6.4 0-12.8-2.4-17.7-7.3-9.8-9.8-9.8-25.6 0-35.4L669.6 512 301.3 143.7c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0l386 386c9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#1A2332" p-id="5835"></path>
                    </svg></i>
                </div>
                <div class="rili-bottom">
                  <ul class="flex_between_box">
                    <li class="flex_between_box_li" v-for="(item, index) in monthList" :key="index"
                      :class="ActiveIndex == index ? 'flex_between_box_li_active' : ''" @click="Active(item.value,index)">{{ item.label
                      }}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="timeLine">
              <h3 class="LoginTime">{{ $t('MyAccount.RecentLogin') }}</h3>
              <el-timeline>
                <el-timeline-item v-for="(activity, index) in activities" :key="index" :color="activity.color"
                  :size="activity.size">
                  <!-- :timestamp="activity.timestamp" -->
                  {{ activity.loginTime }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </ul>
        </div>
      </div>
      <!-- 注销 后期放到computent里 -->
      <div class="DeleteAccount" v-else>
        <div class="DeleteAccount-top">
          <el-steps :active="steps" align-center space="20%">
            <el-step title="Notice and Agreement"></el-step>
            <el-step title="Resource Processing"></el-step>
            <el-step title="Cancellation Result"></el-step>
          </el-steps>
        </div>
        <div class="DeleteAccount-bottom" v-if="steps == 1">
          <h2 class="DeleteAccount-head">
            Please carefully read the agreement in the following instructions and links
          </h2>
          <div class="DeleteAccount-content">
            <h3 class="">Important information for account cacellation</h3>
            <div class="DeleteAccount-body">
              Submitting an account cancellation application is an irreversible operation. To ensure the safety of your
              account and property, and to maintain normal public order, please confirm the following information before
              submitting your Alibaba Cloud<br>
              account cancellation request:<br>
              1. The person submitting the account cancellation request is either yourself or a legally authorized
              agent/representative of the account holder. In the latter case, the agent/representative shall inform the
              account holder of this notice and all
              documents related to the cancellation process, and ensure that they have understood and agreed to all the
              contents of the aforementioned documents.<br>
              2. The account you applied to cancel is in a stable and secure state (e.g. has not experienced any risks
              such as theft or being banned, and has not undergone any sensitive information changes such as changing
              passwords or changing phone
              bindings in the past three months)<br>
              3. You submitted an account cancellation application to us through a commonly used security device;<br>
              4. There are no unfulfilled contracts, outstanding fees, unpaid taxes, or other obligations that should be
              fulfilled according to laws and regulations under your account;<br>
              5. The binding relationship or external authorization between your account and other third-party network
              applications (such as websites, apps) has been terminated, or you can be confident that not terminating
              such binding relationship or not
              revoking such external authorization will not have any adverse effects on yourself or any third party;<br>
              6. All your data under your Alibaba Cloud account has been migrated and properly backed up, or you
              completely waive the right to retain or retrieve such data;<br>
              7. You are not submitting an account cancellation application to avoid ongoing or upcoming disputes or
              lawsuits, or to evade regulatory oversight from authorities, or to circumvent relevant laws and
              regulations.
            </div>
            <h3 class="">Reminder again</h3>
            <div class="DeleteAccount-body">
              Submitting an account cancellation application is an irreversible operation.<br>
              After account cancellation, you will no longer be able to log in to Alibaba Cloud websites, forums, or
              apps, access the control panel or cloud site control panel, or perform other operations that rely on
              account permissions.<br>
              Your personal information, transaction records, business data, historical information, etc. under this
              account will not be retrievable.<br>
              The system may automatically create cloud product service associated roles under your account for resource
              cleaning. For detailed instructions, please refer to "Account Cancellation - Account Cancellation".<br>
              If you wish to maintain any cloud services (including cloud sites) associated with this account and only
              wish to terminate some products/resources, please do not proceed with further actions.
            </div>
            <h3 class="">Confirm cancellation</h3>
            <div class="DeleteAccount-body">
              You are trying to cancel your Alibaba Cloud account. Please ensure that there are no valid transactions
              under the account and do not perform any operations during the account cancellation period to avoid
              cancellation failure.<br> After cancellation, you will no longer be able to use any Alibaba Cloud
              services, and your account and data will also be lost.
            </div>
            <div style="margin: 40px 0px;" class="flex_center_start_box"> <el-checkbox style="margin-right: 10px;"
                v-model="checked"></el-checkbox>I have understood the account cancellation agreement. After submitting
              the application, my account {{ Accountid }} will be cancelled, and the content, data, and services
              contained therein cannot be restored</div>
            <div style="display: flex;"> <el-button class="btn_blue flex_center" :disabled="!checked" @click="steps++;NextCancellation()"
                style="width: 180px;">Next</el-button> <el-button class="btn_blue btn_eee flex_center"
                style="margin-right: 10px;width: 180px;" @click="DeleteAccount = true">{{ $t('MyAccount.Cancel') }}</el-button> </div>
          </div>
        </div>
        <div class="DeleteAccount-bottom" v-if="steps == 2">
          <div v-if="step2One">
            <div class="DeleteAccount-step2-top">
              <h2 class="DeleteAccount-step2-head">
                <b style="color: #F56B6B;">{{  yourUsagelist.length}}</b> item to be processed (of which <b style="color: #F56B6B;">{{yourUsagelistNored.length}}</b> results
                must be manually processed)
              </h2>
              <div class="DeleteAccount-body">
                It is recommended to handle the manual items first, and then recheck and confirm the cancellation before
                entering the account cancellation quiet period. The account cancellation is expected to be completed at
                17:17 on July 22, 2024.
              </div>
            </div>
            <div class="DeleteAccount-step2-table">

              <div class="DeleteAccount-body">
                <el-table :data="yourUsagelist" style="width: 100%" @selection-change="handleSelectionChange"
                  empty-text="No Data">
                  <el-table-column prop="Type" :label="$t('Ownership.Type')" align="center">
                    <template slot-scope="scope">
                      <span class="table-content">{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column prop="type" label="Products/Services" align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span class="table-content">{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="desc" label="Description" align="center" show-overflow-tooltip>

                  </el-table-column>
                  <el-table-column prop="" label="Operation" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="table-content " style="" >
                        <span style="color: #1290C9;" @click="DeleteAccount=true;steps=1">Go Handle It</span>
                        <span style="color: #1290C9;margin-left: 30px;" v-if="scope.row.type=='may give up'" @click="Operation(scope.row)">Give Up</span>
                      </div>
                    </template>
                  </el-table-column>

                </el-table>
                <div style="display: flex;margin-top: 40px;">  <el-button class="btn_blue flex_center" @click="NextCancellation()"
                    style="width: 180px;">Recheck</el-button> <el-button class="btn_blue flex_center" @click="steps--"
                    style="width: 180px;">Back</el-button> <el-button class="btn_blue btn_eee flex_center"
                    style="margin-right: 10px;width: 180px;" @click="DeleteAccount = true">{{ $t('MyAccount.Cancel') }}</el-button> </div>
              </div>
            </div>
          </div>
          <div v-if="!step2One">
            <div class="step2One">
              <div><img src="../../../assets//img/hudun.png" alt=""></div>
              <h2 class="step2One-head">Resource check passed!</h2>
              <h2 class="step2One-text">There are no resources to be processed for the current account. You can click on
                the
                bottom left corner to confirm the cancellation and proceed with the cancellation operation</h2>
              <div style="display: flex;justify-content: center"> <el-button class="btn_blue flex_center" @click="steps++;cancelAccount()">Confirm
                  Cancellation</el-button> <el-button class="btn_blue flex_center" @click="steps--">Back</el-button>
                <el-button class="btn_blue btn_eee flex_center" style="margin-right: 10px;width: 180px;"
                  @click="step2One = true">  {{ $t('MyAccount.Cancel') }}</el-button>
              </div>

            </div>
          </div>

        </div>
        <div class="DeleteAccount-bottom" v-if="steps == 3">

          <div>
            <div class="step2One">
              <div><img src="../../../assets//img/shizhong.png" alt=""></div>
              <h2 class="step2One-head">Cancelling in progress</h2>
              <h2 class="step2One-texttwo">The system has entered the logout process, which may take some time. After
                the logout
                is completed, the logout result will be sent to your email. Please check your inbox carefully.</h2>
              <h2 class="step2One-texttwo" style="color: #F56B6B;">Attention: Please do not operate the account during
                this
                period, otherwise it may result in cancellation failure or other uncontrollable consequences</h2>

              <!-- <div style="display: flex;">      <el-button class="btn_blue flex_center" @click="steps++" >Confirm Cancellation</el-button>    <el-button class="btn_blue flex_center" @click="steps--" >Back</el-button>   <el-button class="btn_blue btn_eee flex_center"  style="margin-right: 10px;width: 180px;" @click="step2One=true">Cancel</el-button> </div> -->

            </div>
          </div>

        </div>
      </div>
    </div>
    <el-dialog :visible.sync="ConfirmDialog" center :close-on-click-modal="true"  @close="closeDialog"
      custom-class="dialog_normalsuo" :append-to-body="true">
      <div>
        <div class="detail_cont">
          <h3>Confirm Again</h3>
          <div class="detail_cont_text">
            1. After the instance is released, <span style="color: #F56B6B;">it cannot be restored</span>:
            Please backup the relevant business data before confirming the release;
            <br />
            2. After the balance is released, <span style="color: #F56B6B;">it cannot be withdrawn</span>:
            If you need to withdraw, please withdraw separately and then cancel your account;
            <br />
            3. Prepaid instances that have not yet expired <span style="color: #F56B6B;"> will be released directly
              without
              refund processing</span>:
            If you need a refund, please go through the refund process separately before canceling your account.
          </div>
          <div style="margin: 20px 0px;" class="flex_center_start_box Confirmcheckbox"> <el-checkbox
              style="margin-right: 10px;" v-model="checkedTwo"></el-checkbox>I am fully aware of the risks and authorize
            the
            waiver of relevant rights and continue with account cancellation</div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export btn_exportCCC" @click="ConfirmDialog = false"
          style="margin-right: 20px;">      {{ $t('MyAccount.Cancel') }}</el-button>
        <el-button class="btn_export" @click="onSubmitquxiao()">Confirm</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="DeleteDialog" center :close-on-click-modal="true"  @close="DeleteDialog=false"
      custom-class="dialog_normalsuo" :append-to-body="true">
      <div>
        <div class="detail_cont">
         
          <div class="detail_cont_text" v-if="userType==2" style="background-color: #fff;">
            Your account is a corporate user and your corporate user identity is already in use, so you cannot cancel the account. If you need to cancel your account, please contact your enterprise administrator. After deactivating your enterprise user identity, you can cancel your account.presentative.
          </div>
          <div class="detail_cont_text" v-if="userType==3" style="background-color: #fff;">
            Your account is a corporate user with administrator status and cannot be cancelled. If you need to cancel, please contact your sales representative.
          </div>
         
        </div>
      </div>
  
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import crypto from '@/utils/crypto';
import { mapGetters, mapActions, mapState } from "vuex";
import { UploadImg, clearUserImage, getDashboard } from "@/api/userApi";
import { LoginOut, sendEmailCode,changePwd,giveUpTasksForCancelAccount, changeUserAccount, handleAccountOwnership,showTasksForCancelAccount ,cancelAccount,showLoginHistoryDataByYM} from "@/api/api.js";
import {
  getoptions,
  getUserSimpleInfo
} from "@/api/companyApi";
import ReLogin from "../../../components/ReLogin.vue";
export default {
  mixins: [mixins1],
  components: {
    ReLogin
  },
  data() {
    return {
      reLoginVis: false,
      userinfo: JSON.parse(localStorage.getItem('userInfo')),
      value1: "",
      checked: false,
      steps: 1,
      CategoryVal: "",
      window: window,
      PasswordChange: false,
      IndicatorsValType: "",
      Edit: true,
      EditOne: true,
      EditTwo: true,
      DeleteAccount: true,
      ActiveIndex: new Date().getMonth() ,
      AvtiveValue:new Date().getMonth()+ 1,
      EditTree: true,
      password: JSON.parse(localStorage.getItem('userInfo')).userInfo.passwordHash,
      passwordtwo:'',
      passwordtree:'',
      radio: '1',
      text: [],
      imgedit: false,
      Accountid: JSON.parse(localStorage.getItem('userInfo')).userInfo.email,
      conInputType: "password", //查看密码
      averageLoginTime: '',
      lastLogDur: '',
      recentLoginTime: '',
      totalLogins: '',
      setTimeForFlag: true,
      setTimeFor: '',
      Emailcode: '',
      timerFor: null,
      ConfirmDialog: false,
      step2One: true,
      Selectable: [],
      checkedTwo: '',
      YearNum: '2025',

      yourUsagelist: [],
      yourUsagelistNored:[],
      monthList: [
        {
          label: 'Jan.',
          value: '01',
        },
        {
          label: 'Feb.',
          value: '02',
        },
        {
          label: 'Mar.',
          value: '03',
        },
        {
          label: 'Apr.',
          value: '04',
        },
        {
          label: 'May.',
          value: '05',
        },
        {
          label: 'Jun.',
          value: '06',
        },
        {
          label: 'Jul.',
          value: '07',
        },
        {
          label: 'Aug.',
          value: '08',
        },
        {
          label: 'Aep.',
          value: '09',
        },
        {
          label: 'Oct.',
          value: '10',
        },
        {
          label: 'Nov.',
          value: '11',
        },
        {
          label: 'Dec.',
          value: '12',
        },
      ],
      activities: [
        // {
        //   content: "支持使用图标",
        //   timestamp: "2018-04-12 20:46",
        //   type: "primary",
        //   color: "#1290C9",
        //   // icon: 'el-icon-more'
        // },
      ],
  

      Enterprisecertification: {
        type: this.radio,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        countryCode: '',
        address1: '',
        city: '',
        zipCode: '',
        companyName: ''
      },
      Peoplecertification: {
        type: this.radio,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        countryCode: '',
        address1: '',
        city: '',
        zipCode: '',
        companyName: ''
      },
      giveUpid:[],
      provinceOptions: [],
      inputType: false, //查看密码
      inputTypetwo:false,
      inputTypetree:false,
      DeleteDialog:false,
      userType:1,

      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
    };
  },
  computed: {
    ...mapGetters({
      token: "users/token",
    }),
    ...mapState({
      token: "users/token",
    }),
    type() {
      return this.inputType ? "text" : "password";
    },
    loginAndCreateDialog: {
      get() {
        return this.loginAndCreatePop;
      },
      set(newValue) {
        this.$emit("update:loginAndCreatePop", newValue);
      },
    },
  },
  beforeDestroy() { },
  destroyed() { },
  created() {
    this.imageUrl = JSON.parse(localStorage.getItem('userInfoImg')) == undefined ? this.imageUrl : JSON.parse(localStorage.getItem('userInfoImg'))
    this.$bus.$emit('changeImageUrl', this.imageUrl);
this.getUserSimpleInfo()
  },
  mounted() {
    this.getCountry();
    this.password=crypto.decrypt(this.password);

   
    this.getDashboardList()
  
    this.Enterprisecertification = {
      type: this.radio,
      firstName: this.userinfo?.companyInfo?.firstName,
      lastName: this.userinfo?.companyInfo?.lastName,
      phoneNumber: this.userinfo?.companyInfo?.phoneNumber,
      email: this.userinfo?.companyInfo?.email,
      countryCode: this.userinfo?.companyInfo?.countryRegion,
      address1: this.userinfo?.companyInfo?.address,
      // provinceCode: this.userinfo?.companyInfo?.provinceCode,
      city: this.userinfo?.companyInfo?.city,
      zipCode: this.userinfo?.companyInfo?.zipCode,
      companyName: this.userinfo?.companyInfo?.companyName
    }
   
  },

  methods: {
    getUserSimpleInfo(){
      getUserSimpleInfo().then(res=>{
        this.userType=res.data.userType
        if( this.userType!=1){
  this.radio='2'
 }
 this.Peoplecertification = {
        type: this.radio,
        firstName: res.data?.userInfo?.firstName,
        lastName: res.data?.userInfo?.lastName,
        phoneNumber: res.data?.userInfo?.phoneNumber,
        email: res.data?.userInfo?.email,
        countryCode: res.data?.userInfo?.countryRegion,
        address1: res.data?.userInfo?.address,
        city: res.data?.userInfo?.city,
        zipCode: res.data?.userInfo?.zipCode,
        companyName: res.data?.userInfo?.companyName
      }
      })
    },
    DeleteAccountedlog(){
      
      if(this.userType==3||this.userType==2){
        this.DeleteDialog=true
      }else{
      this.DeleteAccount = false

      }
    },
        ChangePassword(){
          crypto.encrypt(this.passwordtwo)
          
          

          let params={
            originalPassword:crypto.encrypt(this.password),
            newPassword:  crypto.encrypt(this.passwordtwo),
            confirmPassword:crypto.encrypt(this.passwordtree)
          }
          changePwd(params).then(res=>{
            if(res.code==200){
              this.$message({
          message: 'Please Login in!',
          type: 'error',
          duration: 3000
        })
        sessionStorage.clear()
        setTimeout(() => {
          window.location.href = '/'
        }, 2000);
        localStorage.removeItem('token')

            }else{
              this.$message.error(res.msg)
            }
          })
        },

        Active(vaue,index) {
        this.ActiveIndex = index
        this.AvtiveValue=vaue
        showLoginHistoryDataByYM({
          dateStr:this.YearNum+'-'+vaue
      
        }).then(res=>{
          this.activities = res.data
          this.activities.map((item, index) => {
            item.color = "#1290C9"
          })
        })
      },
    cancelAccount(){
      cancelAccount().then(res=>{
        if(res.code==200){
          this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
        }else{
          this.$message({
          message: res.msg,
          center: true,
          type: "error",
        });
        }
      })
    },
    // Give Up
    Operation(row){
      this.ConfirmDialog=true
      this.giveUpid=row
     
    },
    // 获取未处理事件结果
    NextCancellation(){
      showTasksForCancelAccount().then(res=>{
        if(res.code==200){
          this.yourUsagelist=res.data
         this.yourUsagelistNored=res.data.filter(item=>item.type!='may give up')
          if(this.yourUsagelist.length==0){
         
      this.step2One = false
      }
        }else{
          this.yourUsagelist=[]
        }
      })
    },
    onSubmitquxiao() {
      giveUpTasksForCancelAccount({taskTypeId:this.giveUpid.id}).then(res=>{
        this.$message({
            message: res.msg,
            center: true,
            type: "success",

          });
        
      })
      this.ConfirmDialog = false
      this.NextCancellation()
      if(this.yourUsagelist.length==0){
      this.step2One = false
      }
    },
    closeDialog() {
      this.ConfirmDialog = false
    },
    // 认证
    ChangeOwnership() {
      let params = {
      }
      if (this.radio == 2) {
        this.Enterprisecertification.type = this.radio
        params = this.Enterprisecertification
      } else {
        params = this.Peoplecertification
      }

      handleAccountOwnership(params).then(res => {
        if (res.code == -1) {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        } else {
          localStorage.setItem('renzheng', true)
          this.$message({
            message: res.msg,
            center: true,
            type: "success",

          });
        }

      })
    

    },
    //获取国家
    getCountry() {
      this.countryOptions = JSON.parse(localStorage.getItem('countryList'))[0].countryList;
    },
    changeCountry() {
      this.Peoplecertification.city = '';
      this.Enterprisecertification.city = '';
      this.provinceOptions = [];
      if (this.Peoplecertification.countryCode || this.Enterprisecertification.countryCode) {
        this.getProvince();
      }
    },
    //获取省市
    async getProvince() {
      const params = {
        page: 1,
        pageSize: 10,
        company_country: this.Enterprisecertification.countryCode ? this.Enterprisecertification.countryCode : this.Peoplecertification.countryCode,
      };
      await getoptions(params).then(res => {
        if (res && res.code) {
          let list = res.data.geographicalLocation.length > 0 ? res.data.geographicalLocation[0].companyProvince : [];

          this.provinceOptions = list;
        }
      });
    },
    Deletapicture() {
      clearUserImage().then(res => {
        this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
      })
      this.imageUrl = ''
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      delete userInfo.userInfo.userImg;
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      localStorage.removeItem("userInfoImg");
      this.$bus.$emit('changeImageUrl', '');
      location.reload(true)

    },
    changepass(){
      this.EditTwo = !this.EditTwo;this.PasswordChange=false;
      this.passwordtree='';this.passwordtwo='';
      this.password=JSON.parse(localStorage.getItem('userInfo')).userInfo.passwordHash
      this.password=crypto.decrypt(this.password);
    },
    // 认证
    Changauthentication() {
      this.EditTree = !this.EditTree
    },
    // 发送验证码
    sendCodeForgot() {
      this.errFlagForSucess = false;
      this.errFlagForErr = false;
      if (this.Accountid == '') {
        return;
      }
      this.checkForgot();
    },
    //倒计时
    async checkForgot() {
    
      // this.errFlagForSucess = true;
      const params = {
        // email: JSON.parse(localStorage.getItem('userInfo')).userInfo.email,
        email: this.Accountid,
        source: '10',
      };
      const codeRes = await sendEmailCode(params);
      if (codeRes.code == 200) {
        if (!this.timerFor) {

        const time = 60;
        this.setTimeFor = time;
        this.setTimeForFlag = false;
        this.timerFor = setInterval(() => {
          if (this.setTimeFor > 1 && this.setTimeFor <= time) {
            this.setTimeFor--;
          } else {
            this.setTimeForFlag = true;
            clearInterval(this.timerFor);
            this.timerFor = null;
          }
        }, 1000);
      }

        this.$message({
          message: codeRes.msg,
          center: true,
          type: "success",
        });
        // this.errFlagForSucess = true;
        codeRes.msg;
      } else {
        this.$message({
          message: codeRes.msg,
          center: true,
          type: "error",
        });
        // this.errFlagForErr = true;
        // this.errFlagForErrTxt = codeRes.msg;
      }
    },
    getDashboardList() {
      getDashboard().then(res => {
        if (res.code == 200) {
          this.activities = res.data.rows
          this.activities.map((item, index) => {
            item.color = "#1290C9"
          })
          this.totalLogins = res.data.totalLogins
          this.averageLoginTime = res.data.averageLoginTime
          this.lastLogDur = res.data.lastLogDur
          this.recentLoginTime = res.data.recentLoginTime
        }
      }).catch(err => {
        this.reLoginVis = String(err).includes('403')
      })
    },
    SubmitLoginOut() {
      LoginOut({}).then((res) => {

        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          localStorage.removeItem("token");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userInfoImg");
          window.location.href = "/";
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("userInfo");
          window.location.href = "/";
          localStorage.removeItem("userInfoImg");
        }
      });
    },
    ChangeAccount(){
this.EditOne =!this.EditOne ;
this.Accountid=JSON.parse(localStorage.getItem('userInfo')).userInfo.email
this.Emailcode=''
    },
    // 修改 Account ID
    ChangeAccountid() {
      changeUserAccount({
        email: this.Accountid,
        verificationCode: this.Emailcode,

      }).then(res => {
        if (res.code == 200) {
          this.Accountid = res.data
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          sessionStorage.clear()
        setTimeout(() => {
          window.location.href = '/'
        }, 3000);
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        sessionStorage.removeItem('menuItem')
        }else{
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }

      })

    },
    handlePictureCardPreview(file) {
    

      this.imageUrl = file.url;
    },
    handleAvatarSuccess(res, file) {

      // this.imageUrl=file.url
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    imgchange(file) {

      const reader = new FileReader();

      reader.onload = (event) => {
        const binaryData = event.target.result; // 获取二进制数据

        const formData = new FormData();
        formData.append('avatarfile', new Blob([binaryData]), file.name);

        UploadImg(formData).then(res => {
          if (res.code == 200) {
            //
            // this.imageUrl = ' http://52.88.7.33:8066/csi/usercenter/download/resource?resource=' + res.data;
            this.imageUrl = 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + res.data;
            localStorage.setItem('userInfoImg', JSON.stringify(this.imageUrl));
            location.reload();
            // 更新 localStorage
          } else {
            this.$message.error(res.msg);
          }
        });


      };

      reader.readAsArrayBuffer(file.raw); // 启动读取
    },
    beforeAvatarUpload(file) {

      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("Uploading avatar images can only be in JPG format!");
      }
      if (!isLt2M) {
        this.$message.error("Uploading avatar images can only be in JPG format!");
      }

      return isJPG && isLt2M;
    },
    handleSelectionChange(val) {
      this.Selectable = val
    },


  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.form-email {
  display: flex;
  width: 100%;
}

.block-con-body-text {
  word-break: keep-all;
  text-align: justify;
  font-size: 1rem;
  color: #022955;
}

.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.item_txtcolor1 {
  color: #1290c9;
}

.item_txtcolor2 {
  color: #55b419;
}

.item_txtcolor3 {
  color: #ffa000;
}

.das_top_item .color1 {
  background: rgba(18, 144, 201, 0.12);
}

.das_top_item .color2 {
  background: rgba(85, 180, 25, 0.12);
}

.das_top_item .color3 {
  background: rgba(255, 160, 0, 0.12);
}

.das_top_item .color4 {
  background: #ff7600;
}

.das_top_item .item_img img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: left;
}

.das_top_item .item_group {
  margin-left: 0.7142857142857143rem;
  font-size: 1.2857142857142858rem;

  /* width: 17.142857142857142rem; */
}

.das_top_item .item_lab {
  display: block;
  color: #1a2332;

  margin-top: 0.35714285714285715rem;
}

.item_txt {
  font-size: 1.857142857143rem;
  text-align: center;
}

.cont_m {
  margin-top: 2.142857142857143rem;
  margin-bottom: 5.714285714285714rem;
}

.country_box {
  margin-top: 4.285714285714286rem;
}

.country_box .title {
  margin-bottom: 0;
}

.margin-bottom20 {
  margin-bottom: 1.4285714285714286rem;
}

.title_txt {
  font-size: 1.1428571428571428rem;
  font-family: 'DMSans Bold';
}

.title_txt img {
  width: 1.4285714285714286rem;
  margin-right: 0.5714285714285714rem;
}

.c_d_buttom {
  justify-content: flex-end;
  /* margin-top: 1.4285714285714286rem; */
  margin-bottom: 0;
}

.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  border-radius: 0.5714285714285714rem;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

.sel_box {
  margin-right: 1.7857142857142858rem;
  width: 40%;
  min-width: 28.571428571428573rem;
  position: relative;
}

.sel_box /deep/ .el-input__inner {
  border-color: #ccc !important;
  border-radius: 0.5714285714285714rem;
  font-size: 1.285714285714286rem;
  color: #1a2332;
}

.sel_box h4 {
  font-size: 1.7142857142857142rem;
  font-family: 'DMSans Bold';
  color: #1a2332;
  line-height: 2.142857142857143rem;
  margin-bottom: 0.7142857142857143rem;
  font-weight: 400;
}
.rili-top span{
  font-family: 'DMSans Bold'!important;
}
.das_top_cont {
  /* margin-top: 3.5714285714285716rem; */
}

.das_top_item {
  width: 32.5%;
  padding: 1.4285714285714286rem;
  /* border-radius: 1rem; */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
}

.das_top_item .item_img {
  width: 4.285714285714286rem;
  height: 4.285714285714286rem;
  line-height: 5.571428571428571rem;
  text-align: center;
  border-radius: 50%;
}

.das_top_item .item_title {
  font-size: 1.2857142857142858rem;
  color: #022955;
  margin: 0.7142857142857143rem 0 0.7142857142857143rem;
  text-align: center;
}

.top_tab {
  margin-top: 2.857142857142857rem;
}

/deep/ .el-table {
  margin-top: 2.142857142857143rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}


/deep/ .el-table th.el-table__cell>.cell {
  font-family: 'DMSans Bold';
}

.last-colmun {
  padding: 2rem 0rem;
  border-bottom: 0.07142857142857142rem solid #ebeef5;
}

.dingwei {
  position: absolute;
  top: -2.142857142857143rem;
  right: 0rem;
}

/deep/ .el-descriptions-item__cell {
  padding-bottom: 2.142857142857143rem !important;
}

/deep/ .avatar-uploader .el-upload {
  border: 0.07142857142857142rem dashed #d9d9d9;
  border-radius: 0.42857142857142855rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/* 日历大小 */
.el-range-editor.el-input__inner {
  /* width: 16rem !important; */
  padding: 0.21428571428571427rem 0.21428571428571427rem;
}

.el-date-editor /deep/ .el-range__icon {
  font-size: 1.1428571428571428rem;
  margin-left: -0.35714285714285715rem;
  color: #1a2332;
  /* float: left; */
  line-height: 2.2857142857142856rem;
  position: relative;
  left: 47%;
}

.information-content {
  display: flex;
}

.btn_eee {
  background: #eee;
  color: #1a2332;
}

.account-left-right {
  margin-left: 2.142857142857143rem;
}

.account-left-right h3 {
  font-size: 1.857142857143rem;
  color: #1a2332;
  line-height: 2.5714285714285716rem;
}

.account-left {
  margin-bottom: 2.142857142857143rem;
}

.account-left-right h4 {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  margin-top: 0.42857142857142855rem;
  line-height: 1.6428571428571428rem;
}

.account-left-right .account-left-right-time {
  font-size: 1.1428571428571428rem;
  color: #666666;
  margin-top: 1.285714285714286rem;
}


@media screen and (max-width: 1441px) {
  .account-left-right .account-left-right-time {
    font-size: 12px;
  }
  .btn_blue{
    font-size: 14px;
    width: max-content;
  }
}
.avatar-uploader /deep/ .el-upload {
  /* border: 0.07142857142857142rem dashed #d9d9d9; */
  /* border-radius: 50% !important; */
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: none;
  /* height: 8.571428571428571rem;
  width: 8.571428571428571rem; */
}

.avatar-uploader .el-upload:hover {
  border: none !important;
}

.avatar {
  height: 8.571428571428571rem;
  width: 8.571428571428571rem;
  line-height: 8.571428571428571rem;
  border-radius: 50%;
  display: block;
}

.account-left-box {
  padding-bottom: 2.142857142857143rem;
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

.content-center {
  margin-top: 2.142857142857143rem;
}

.AccountOwnership {
  margin-top: 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
}

.ul-tab {
  width: 80%;
  margin: auto;
}

.ul-tab-title {
  font-size: 1.2857142857142858rem;
  font-weight: normal;
  color: #8497ab;
}

.ul-tab-text {
  font-size: 1.285714285714286rem;
  font-weight: normal;
  color: #1a2332;
  margin-top: 0.8571428571428571rem;
}

/deep/ .el-timeline-item__wrapper {
  top: -0.21428571428571427rem;
  position: relative;
  padding-right: 2.5rem;
}

/deep/ .el-radio__label {
  font-size: 1.285714285714286rem;
  color: #1A2332;
}

.postiverelatibve {
  position: relative;
  overflow: hidden;
}

.postiveaboust {
  position: absolute;
}

.avatartex {
  width: 8.571428571428571rem;
  height: 8.571428571428571rem;
  background: #F5F5F5;
  font-size: 4.285714285714286rem;
  color: #A2A9B0;
  text-align: center;
}

/deep/ .el-timeline {
  height: 26.428571428571427rem;
  overflow-y: scroll;
  overflow-x: initial;
  /* padding: 1.4285714285714286rem; */
  padding-right: 1.4285714285714286rem;
  /* overflow: auto; */
}

/deep/ .el-timeline-item__tail {
  right: 0.5rem;
  left: auto;
}

/deep/ .el-timeline-item__node--normal {
  right: 0.2857142857142857rem;
  width: 0.5714285714285714rem;
  height: 0.5714285714285714rem;
  left: auto;
  top: 0.14285714285714285rem;
}

.LoginTime {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
  margin-bottom: 1.4285714285714286rem;
  font-family: 'DMSans Bold';
  text-align: center;
}
/deep/ .el-timeline-item {
  padding-bottom: 1.0714285714285714rem;
}
/deep/ .el-timeline-item__content {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
}
.ul-tab-left {
  width:36.438em;
  margin-right: 3.5714285714285716rem;
}

.send_time {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  position: absolute;
  right: 2.857142857142857rem;
  top: 0.7142857142857143rem;
}

.send_txt {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  line-height: 2.142857142857143rem;
  position: absolute;
  right: 0.7142857142857143rem;
  text-align: center;
  border-left: 0.07142857142857142rem solid #ccc;
  padding-left: 0.7142857142857143rem;
  top: 0.7142857142857143rem;
  text-decoration: none;
  cursor: pointer;
}

.el-select-dropdown__item {
  font-size: 1.285714285714286rem !important;
  color: #1A2332;
}

.ul-tab-left-rili {
  background: #F5F5F5;
  border-radius: 1.7142857142857142rem;
  padding: 2.142857142857143rem 1.0714285714285714rem; 
  text-align: center;
  padding-bottom: 2.857142857142857rem;
}

.rili-top {
  font-size: 1.285714285714286rem;
  color: #1A2332;
  width: 71.9%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  border-radius: 1.7857142857142858rem;
  padding: 0.35714285714285715rem;
}

.rili-top-left {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: #F5F5F5
}

.iconrili {
  position: relative;
  top: 0.14285714285714285rem;
  right: 0.35714285714285715rem;
}

.flex_between_box_li {
  margin-top: 2.142857142857143rem;
  width: 6.428571428571429rem;
  height: 6.428571428571429rem;
  padding: 1.4285714285714286rem 1.2142857142857142rem;
  margin-left: 1.0714285714285714rem;
  margin-right: 1.0714285714285714rem;
  background: #FFFFFF;
  border-radius: 1.7142857142857142rem;
  font-size: 1.285714285714286rem;
  font-family: 'DMSans Bold';
  line-height: 3.2142857142857144rem;
}

.flex_between_box_li_active {
  color: #1290C9;
  border: 0.07142857142857142rem solid #1290C9;

}

.flex_between_box {
  flex-wrap: wrap;
}

.DeleteAccount-top {
  padding: 1.1428571428571428rem;
  background: #FFFFFF;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.2857142857142857rem;
}

.el-steps {
  justify-content: center;
}

/deep/ .el-step__icon {
  width: 3.142857142857143rem;
  height: 3.142857142857143rem;
  background: #1290C9;
  background: #F5F5F5;
  /* border: 0.07142857142857142rem solid #1290C9; */
  color: #A2A9B0;
}

/deep/ .el-step__icon.is-text {
  border: none;
  color: #A2A9B0;
}

/deep/ .el-step__icon-inner {
  font-size: 1.7142857142857142rem;
}

/deep/.el-step__title.is-process {
  color: #A2A9B0;

}

/deep/ .el-step__title.is-finish {
  font-size: 1.1428571428571428rem;
  color: #1290C9
}

/deep/ .el-step.is-center .el-step__line {
  top: 50%;
}

/deep/ .is-finish .is-text {
  color: #FFFFFF !important;
  background: #1290C9 !important;
}

.DeleteAccount-bottom {
  margin-top: 0.7142857142857143rem;
  padding: 2.142857142857143rem 2.857142857142857rem;
  background: #FFFFFF;
  box-shadow: 0rem 0.14285714285714285rem 0.2857142857142857rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 0.2857142857142857rem;
  font-size: 1.2857142857142858rem;
  color: #1A2332;
}

.DeleteAccount-head {
  font-size: 1.7142857142857142rem;
  color: #1A2332;
  line-height: 2rem;
  height: 2.142857142857143rem;
  text-align: center;
  /* margin-bottom: 2.857142857142857rem; */
}

.DeleteAccount-content h3 {
  margin-top: 2.857142857142857rem;
  margin-bottom: 1.4285714285714286rem;
}

.DeleteAccount-body {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
  line-height: 2.4285714285714284rem
}

/deep/ .el-checkbox__label {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
  line-height: 2.4285714285714284rem;

}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #1A2332;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #1290C9 !important;
}

.DeleteAccount-step2-head {
  font-size: 1.2857142857142858rem;
  line-height: 1.5rem;
  color: #1A2332;
  margin: 1.4285714285714286rem 0rem;
}

.DeleteAccount-step2-top {
  background: #F5F5F5;
  border-radius: 0.42857142857142855rem;
  padding: 1.4285714285714286rem;
}





.Confirmcheckbox {
  font-size: 1rem;
  color: #1A2332;
  line-height: 1.7142857142857142rem;
}

.step2One {
  width: 65%;
  margin: auto;
  text-align: center;
  padding: 2.142857142857143rem 0rem;
}

.step2One-head {
  margin-top: 1.4285714285714286rem;
  margin-bottom: 2.142857142857143rem;
  font-size: 1.7142857142857142rem;
  color: #1A2332;
  line-height: 2rem;
  text-align: center;
}

.step2One-text {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
  line-height: 2.4285714285714284rem;
  margin-bottom: 5.714285714285714rem;
}

.step2One-texttwo {
  font-size: 1.2857142857142858rem;
  color: #1A2332;
  line-height: 2.4285714285714284rem;
  margin-bottom: 2.857142857142857rem;
}
/deep/ .el-step__head.is-finish {
    color: #fff;
    border-color: #EEEEEE;
}
/deep/ .el-step__line {
  color: #fff;
  background-color: #EEEEEE;
}

.icon_watchun {
  background-image: url("../../../assets/img/watch_ic1.png");
}

.icon_watchon {
  background-image: url("../../../assets/img/watch_ic2.png");
}

.edit_con {
  position: absolute;
  right: 0.8571428571428571rem;
  bottom: 0.7142857142857143rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.857142857142857rem;
  height: 2.857142857142857rem;
  background: rgba(153, 153, 153, 0.3);
  border-radius: 50%;
}

.edit_con .edit_con_icon {
  width: 2.142857142857143rem;
  height: 2.142857142857143rem;
}

.account_base {
  width: 24.285714285714285rem;
}

.role_company {
  /* width:36.428em; */
  padding-left: 2.142857142857143rem;
  border-left: 0.07142857142857142rem solid #dddddd;
}

.role_company h3 {
  line-height: 2.5714285714285716rem;
  font-size: 1.7142857142857142rem;
}

.role_company h4 {
  line-height: 1.7142857142857142rem;
  margin-top: 0.7142857142857143rem;
  font-weight: normal;
}
</style>